import axios from 'axios';
import { composeWithDevTools } from '@redux-devtools/extension';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleWare from 'redux-thunk';
import { INPUT, SYNC, UPDATE, BUSY, BROKEN } from '../../shared/wizard/actions';
import initState from './config';

const framed = location.pathname.split('/')[2] === 'framed';

initState.framed = framed;

const input = (state, action) => ({
  ...state,
  input: {
    ...state.input,
    ...action.payload,
  },
});

const sync = (state, action) => ({
  ...state,
  syncing: typeof action.syncing === 'boolean' ? action.syncing : false,
  output: {
    ...state.output,
    errors: {},
    ...action.payload,
  },
});

function reducer(state, action) {
  switch (action.type) {
  case INPUT: return input(state, action);
  case SYNC: return sync(state, action);
  case BUSY: return { ...state, syncing: true };
  case UPDATE: return { ...state, ...action.payload };
  case BROKEN: return { ...state, broken: true };
  default: return state;
  }
}

export const enhancer = composeWithDevTools(applyMiddleware(thunkMiddleWare));

export const store = createStore(reducer, initState, enhancer);

axios.interceptors.response.use(null, error => new Promise((resolve, reject) => {
  if (error.response.status !== 422) {
    store.dispatch({ type: BROKEN });
  }
  return reject(error);
}));
